import { gql } from 'react-apollo';

export default gql`
  mutation updateInvestorBasicInformation(
    $firstName: String!
    $lastName: String!
    $password: String
    $companyName: String!
    $country: String!
    $address: String!
    $officePhoneNumber: String!
    $mobilePhoneNumber: String
    $city: String
    $state: String
    $street: String
    $zip: String
    $income: String
    $networth: String
  ) {
    updateInvestorBasicInformation(
      input: {
        firstName: $firstName
        lastName: $lastName
        password: $password
        country: $country
        address: $address
        companyName: $companyName
        officePhoneNumber: $officePhoneNumber
        mobilePhoneNumber: $mobilePhoneNumber
        state: $state
        street: $street
        city: $city
        zip: $zip
        income: $income
        networth: $networth
      }
    ) {
      _id
      canViewOffers
      accreditationStatus
      firstName
      lastName
      companyName
      country
      address
      officePhoneNumber
      mobilePhoneNumber
      income
      networth
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateInvestorBasicInformation.js